import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileStorageService {
  private readonly http = inject(HttpClient);

  /**
   * Fetches a file from a URL and returns it as a Blob.
   * This is the correct way to handle potential CORS issues with Firebase Storage.
   * @param url The full URL of the file to fetch.
   * @returns An Observable that emits the file data as a Blob.
   */
  getFileAsBlob(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }
}
